export default __webpack_public_path__ + "static/media/pantry2-before1-1024w.af8119ca.avif";